import { getOrder } from "@commerce-os/contracts";
import { LoadingState } from "@commerce-os/ui";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { useApp } from "../../../app/context";
import { useT } from "../../../app/i18n";
import { QueryError } from "../../../components/query-error";
import { orderKey } from "../../../features/orders/queries";
import { ReturnFormPage } from "../../../features/orders/return-form-page";

export const Route = createFileRoute("/_app/orders/$id_/return")({ component: ReturnRoute });

function ReturnRoute() {
  const { id } = Route.useParams();
  const { t } = useT();
  const { api } = useApp();
  const order = useQuery({
    queryKey: orderKey(id),
    queryFn: ({ signal }) => api.call(getOrder, { params: { id }, signal }),
  });
  if (order.isPending) return <LoadingState label={t("states.loading")} />;
  if (order.isError) return <QueryError error={order.error} onRetry={() => void order.refetch()} />;
  return <ReturnFormPage key={`${id}:${String(order.data.version)}`} order={order.data} mode="return" />;
}
